var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._v("\n  这里是进度管理，但是你还没有权限昂\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }